import { Box } from '@mui/material';

import Icon from './Icon';
import OutlinedCircle from './OutlinedCircle';
import { ChromePill, type ChromeSize } from './ChromePill';

/**
 * Saved, the scope (contract §15): where the Explore | Saved pill was. The
 * bookmark and the check (Maybe and Going), the word, and how many are saved.
 * Filled while Saved is showing; a tap goes to the other scope, keeping the
 * layout and the filters. The strip reserves its widest, a three-digit count
 * (`SAVED_BUTTON_MAX_W`), so the count growing never moves the group.
 */

interface Props {
  on: boolean;
  count: number;
  size: ChromeSize;
  onToggle: () => void;
}

export default function SavedButton({ on, count, size, onToggle }: Props) {
  const glyph = size === 'phone' ? 12.5 : 13.5;
  return (
    <ChromePill
      type="button"
      $on={on}
      $size={size}
      aria-pressed={on}
      aria-label={`Saved, ${count} ${count === 1 ? 'event' : 'events'}`}
      onClick={onToggle}
    >
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: '4px', mr: '2px' }}>
        <Icon name={on ? 'ui:saveOn' : 'ui:save'} size={glyph - 0.5} />
        {on ? <Icon name="ui:scheduleOn" size={glyph} /> : <OutlinedCircle mark="check" size={glyph} />}
      </Box>
      <span>Saved</span>
      <Box component="span" sx={{ opacity: on ? 0.75 : 0.6, fontVariantNumeric: 'tabular-nums' }}>
        {count}
      </Box>
    </ChromePill>
  );
}
